export default {
    routes_edit: "Edit",
}